<template>
<div class="page_iteminfo">
    <div class="zhuxiao">
        <div class="jieshao" v-html="info.text" />
    </div>
    <div class="zhuxiao_bottom" >
        <div class="button cancel" @click="cancel">取消</div>
        <div class="button agree" @click="agree">同意</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: 'zhuxiao-page',
    data() {
        return {
            publicPath: process.env.BASE_URL,
            info: [], // 页面信息
			id: 21, // 21 永久注销账号
			shareConfig: null, // 分享的相关配置
			token: null
        }
    },

    created: function () {
		if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    'naviTitle': '永久注销账号',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback('');
                }
            );
        } else {
            this.token = this.$store.getters.token;
		}
		this.getData()
    },
    methods: {
        cancel() {
            this.$router.back()
        },
        agree() {
            this.$router.push({
				path: '/set/zhuxiao2'
			})
        },
        // 单页内容
        getData() {
            var params = {
                token: this.token,
            }
            if (this.id) {
                params.id = this.id
            }
            this.$api.my.singlePage(params).then(res => {
                if (res.code == 200) {
					this.info = res.result
					// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
					// this.getShareData()
                }
            })
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
                }
            })
		},
		// 分享
        shareFun() {
			var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
			});
            // 分享
            wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: that.info.title, // 分享标题
					desc: '时代记忆', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.$publicData.domain + that.$publicData.logo, // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
